import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpContextToken,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Si la petición pide saltar auth, pasamos directo
    if (req.context.get(BYPASS_AUTH)) {
      return next.handle(req);
    }

    return from(this.auth.loadTokenFromStorage()).pipe(
      switchMap((token) => {
        // Armamos los headers base
        const headers: { [key: string]: string } = {
          'Content-Type': 'application/json; charset=UTF-8',
        };

        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        const authReq = req.clone({ setHeaders: headers });
        return next.handle(authReq);
      })
    );
  }
}
